import { useApi } from "@backstage/core";
import { identityApiRef } from "@backstage/core-plugin-api";
import { catalogApiRef } from "@backstage/plugin-catalog-react";
import { useCallback, useEffect } from "react";
import { useAsyncFn } from "react-use";
import { handleError } from "../handlers";

export const useEntityByGithubSlug = ({
  githubSlug,
}: {
  githubSlug: string;
}) => {
  const identityApi = useApi(identityApiRef);
  const catalogApi = useApi(catalogApiRef);

  const getEntityByGithubSlug = useCallback(async () => {
    try {
      const { token } = await identityApi.getCredentials();
      const entities = await catalogApi.getEntities({}, { token });
      const filtered = entities.items.filter((e: any) => {
        return e.kind === "Component";
      });
      const entity = filtered.find((e: any) => {
        if (!e.metadata.annotations["github.com/project-slug"]) {
          return false;
        }

        return e.metadata.annotations["github.com/project-slug"] === githubSlug;
      });
      if (entity) {
        return entity;
      }
      return { error: "Could not find entity matching GithubSlug supplied" };
    } catch (err: any) {
      return handleError(err);
    }
  }, [catalogApi, identityApi, githubSlug]);

  const [state, fetchEntityByGithubSlug] = useAsyncFn(async () => {
    return await getEntityByGithubSlug();
  }, []);

  useEffect(() => {
    fetchEntityByGithubSlug();
  }, [fetchEntityByGithubSlug]);

  return {
    loading: state.loading,
    error: state.error,
    value: state?.value,
    fetchEntityByGithubSlug,
  };
};
